export default class AssistantProvider {
  type = 'assistant' as const;

  onOpenWritingAssistant: () => void;
  onOpenGlobalAssistant: (params: Record<string, any>) => void;

  constructor({
    onOpenWritingAssistant,
    onOpenGlobalAssistant,
  }: {
    onOpenWritingAssistant: () => void;
    onOpenGlobalAssistant?: (params: Record<string, any>) => void;
  }) {
    this.onOpenWritingAssistant = onOpenWritingAssistant;
    if (onOpenGlobalAssistant) {
      this.onOpenGlobalAssistant = onOpenGlobalAssistant;
    }
  }

  openWritingAssistant() {
    this.onOpenWritingAssistant();
  }

  openGlobalAssistant(params: Record<string, any>) {
    this.onOpenGlobalAssistant(params);
  }
}
